import {
	type DateFieldStatuses,
	type AutoScheduleConfiguration,
	type DateField,
	type IssueSource,
	type Scenario,
	type IssueInferredDateSelection,
	TARGET_START_DATE_FIELD,
	TARGET_END_DATE_FIELD,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/api/types';
import type { Timestamp } from '@atlassian/jira-portfolio-3-portfolio/src/common/types';
import type { PlanningUnit } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import type { IssueSource as PlanWizardIssueSource } from '@atlassian/jira-portfolio-plan-wizard';

export type {
	Scenario as PlanScenario,
	DateFieldTypes,
	DateField,
	DateFieldWarnings,
	// eslint-disable-next-line jira/export/no-external-exports
} from '@atlassian/jira-portfolio-3-portfolio/src/common/api/types';

export {
	DATEFIELD_TYPES,
	DATEFIELD_WARNINGS,
	TARGET_START_END_API_MAP,
	BUILT_IN_DATE_FIELDS,
	// eslint-disable-next-line jira/export/no-external-exports
} from '@atlassian/jira-portfolio-3-portfolio/src/common/api/types';

export type DateConfiguration = {
	baselineStartField: DateField;
	baselineEndField: DateField;
};

export type Plan = Readonly<{
	currentScenarioId?: number;
	id?: number;
	includeCompletedIssuesFor?: number;
}>;

// Note this should only be used for stories and tests
export const fallbackDateConfiguration: DateConfiguration = {
	baselineStartField: TARGET_START_DATE_FIELD,
	baselineEndField: TARGET_END_DATE_FIELD,
};

export type PlanType = 'CROSS_TEAM' | 'CROSS_TEAM_PLANNING' | 'SAFE' | 'STANDARD';

export type PlanInfo = Readonly<{
	currentScenarioId?: number;
	id?: number;
	title: string | null | undefined;
	planningUnit: PlanningUnit;
	issueSources: IssueSource[];
	includeCompletedIssuesFor?: number;
	multiScenarioEnabled?: boolean;
	scenarios?: Scenario[];
	autoScheduleConfiguration?: AutoScheduleConfiguration;
	teamManager: boolean;
	syncStartEnabled: boolean;
	issueInferredDateSelection: IssueInferredDateSelection;
	baselineStartField: DateField;
	baselineEndField: DateField;
	createdTimestamp?: Timestamp;
	useTwpTeams?: boolean;
	// delete this type when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
	zeroMemberTeamsCount?: number;
	isSamplePlan: boolean;
	autoSchedulerEnabled: boolean;
	planStatus: string;
	dateFieldStatuses?: DateFieldStatuses;
	planType?: PlanType;
	creatorAccountId?: string;
}>;

// eslint-disable-next-line jira/export/no-external-exports
export type { IssueSource };

/**
 * A util to cast an ARJ issue source into a PlanWizard issue source.
 * Plan wizard issue sources also include optional `team` and `isScrum` properties,
 * which prevents us from doing a normal cast.
 */

export function toPlanWizardIssueSources(issueSources: IssueSource[]): PlanWizardIssueSource[] {
	return issueSources;
}
